var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoodenStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370 264H264v-40h-26v-42c0-16 6-28 16-38 20-14 30-38 30-62s-10-46-26-62C240 6 216-2 194 0c-36 4-66 34-72 70-4 28 8 56 30 74 10 10 18 24 18 38v42h-28v40H36c-8 0-16 8-16 16v76c0 10 8 16 16 16h6c2 20 20 34 40 34h244c20 0 36-14 40-34h4c8 0 16-6 16-16v-76c0-8-8-16-16-16zM160 134c-18-16-28-38-24-62 4-30 30-54 60-58 18-2 38 4 52 16 14 14 22 32 22 52s-8 40-24 52c-14 12-22 28-22 48v42h-42v-42c0-18-8-36-22-48zm-4 104h94v26h-94v-26zm170 154H82c-14 0-24-8-26-20h296c-4 12-14 20-26 20zm46-36c0 2 0 2-2 2H36s-2 0-2-2v-76c0-2 2-2 2-2h334c2 0 2 0 2 2v76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodenStamp);
export default __webpack_public_path__ + "static/media/WoodenStamp.75704fa6347588549ed7edbac2070cbd.svg";
export { ForwardRef as ReactComponent };